require("popper.js");
const bootstrap = require('bootstrap');

require('./inspiration_filters');
require('./user/edit');
require('./user/catalog_edit');
require('./user/add_inspirations');
require('./inspiration/show');
require('./inspiration/inspiration-list');

if (document.body.classList.contains('products-index')) {
    import ('./products/filters').then(products_filters_module => products_filters_module.setup_products_filters());
}

import('./auth/login-modal').then(login_modal_module => login_modal_module.setup_login_modal());

if (document.body.classList.contains('roladka')) {
    import('./user/roladka').then(roladka_view_module => roladka_view_module.setup_page());
}

let popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'))
popoverTriggerList.map(function (popoverTriggerEl) {
    return new bootstrap.Popover(popoverTriggerEl)
});

const toastElement = document.getElementById('toast-holder');

if (toastElement !== null) {
    let toastElList = [].slice.call(toastElement.querySelectorAll('.toast:not(.hide)'))
    toastElList.map(function (toastEl) {
        let toast = new bootstrap.Toast(toastEl);
        toast.show();
        return toast;
    });
}

$(document).on('click', '.slider-container .slider-btn', (e) => {
    const btn = $(e.currentTarget);
    const slider_container = btn.closest('.slider-container');
    const slider = slider_container.find('.slider');
    if (!slider.length) {
        console.log("Slider element is missing inside container!", slider_container);
        return false;
    }
    let item_width = parseInt(slider.data('item-width'));
    if (!item_width || isNaN(item_width)) {
        const first_item = slider.find('> *').first();
        item_width = first_item.width();
    }
    const number_of_items_scrolled = parseInt(slider.data('items-scrolled')) || 1;
    if (!number_of_items_scrolled || isNaN(number_of_items_scrolled)) {
        console.log("Slider lacks correct data-items-scrolled attribute!", slider);
        return false;
    }
    const direction = btn.hasClass('slider-btn-prev') ? -1 : 1;
    slider[0].scrollLeft += direction * item_width * number_of_items_scrolled;
});
const $itemTemplate = $('template#dropdown-suggest-template');
const $separatorTemplate = $('template#dropdown-suggest-hr-template');
const search_bar_dropdown_el = document.querySelector('#search-bar-results-toggle');
const $searchbarResults = $('#main-search-bar .dropdown-menu');
const search_bar = new bootstrap.Dropdown(search_bar_dropdown_el, {autoClose: 'outside', reference: 'parent'});


const handle_suggest = (data) => {
    if (data.query) {
        $searchbarResults.html("");
        let template = $itemTemplate.html();
        $searchbarResults.append(template.replace('href="#"', `href="${data.query.href}"`).replace('{%name%}', data.query.name));
    }
    if (data.seo.length > 0) {
        data.seo.forEach(function (item, key) {
            let template = $itemTemplate.html();
            $searchbarResults.append(template.replace('href="#"', `href="${item.href}"`).replace('{%name%}', item.name));
        })
    }
    if (data.articles.length > 0) {
        $searchbarResults.append($separatorTemplate.html());
        data.articles.forEach(function (item, key) {
            let template = $itemTemplate.html();
            $searchbarResults.append(template.replace('href="#"', `href="${item.href}"`).replace('{%name%}', item.name));
        })
    }

    search_bar.show();
}

$(document).on('focus', '.search-bar input', (e) => {
    if ($('.search-bar input').val().length > 3) {
        search_bar.show();
    }
});

$(document).on('keyup', '.search-bar input', (e) => {
    let query = $('.search-bar input').val();
    if (query.length > 3) {
        $.get('/api/search?q=' + query, handle_suggest);  // TODO: Tutaj potrzebny jest timeout.
    }
});

const betaAlert = document.getElementById('beta-alert');

$(document).on('click', '#beta-alert button', (e) => {
    betaAlert.remove();
    $.get('/closed_beta');
});

const registerFormButtonSubmit = document.querySelector("form button[type=submit]");
window.reCaptchaCallbackThen = function(response) {
    // console.log(response);
    // if (response.status) {
    //     registerFormButtonSubmit.enable();
    // }
}

window.reCaptchaCallbackCatch = function(response) {
    // console.log(response);
    // registerFormButtonSubmit.disable();
}
